import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import allAPI from "../../api/api";

const initialState = {
  customers: [],
  bulkUploadUsers: [],
  customersMBData:[],
  customerDetail: {},
};

export const getAllCustomers = createAsyncThunk(
  "customersData/getAllCustomers",
  async (payload) => {
    try {
      const response = await allAPI.customers.getCustomers(payload);
      if (response.status === 201) {
        return response.data;
      } else {
        throw new Error(`Unexpected status code: ${response.status}`);
      }
    } catch (error) {
      console.error("API call failed:", error);
      throw error;
    }
  }
);

export const getAllBulkUploadUsers = createAsyncThunk(
  "customersData/getAllBulkUploadUsers",
  async (payload) => {
    try {
      const response = await allAPI.customers.getBulkUploadUsers(payload);
      if (response.status === 201) {
        return response.data;
      } else {
        throw new Error(`Unexpected status code: ${response.status}`);
      }
    } catch (error) {
      console.error("API call failed:", error);
      throw error;
    }
  }
);

export const getMemberBenefitForCust = createAsyncThunk(
  "customersData/getMemberBenefitForCust",
  async (payload) => {
    try {
      const response = await allAPI.customers.getMemberBenefitForCust(payload);
      if (response.status === 201 ||response.status === 200) {
        return response.data;
      } else {
        throw new Error(`Unexpected status code: ${response.status}`);
      }
    } catch (error) {
      console.error("API call failed:", error);
      throw error;
    }
  }
);
export const getAllMemberBenefitForCustomer = createAsyncThunk(
  "customersData/getAllMemberBenefitForCustomer",
  async (payload) => {
    try {
      const response = await allAPI.customers.getAllMemberBenefitForCustomer(payload);
      if (response.status === 201 ||response.status === 200) {
        return response.data;
      } else {
        throw new Error(`Unexpected status code: ${response.status}`);
      }
    } catch (error) {
      console.error("API call failed:", error);
      throw error;
    }
  }
);

export const resetMemberBenefits = createAsyncThunk(
  "customersData/resetMemberBenefits",
  async (payload) => {
    try {
      const response = await allAPI.customers.resetMemberBenefits(payload);
      if (response.status === 201 ||response.status === 200) {
        return response.data;
      } else {
        throw new Error(`Unexpected status code: ${response.status}`);
      }
    } catch (error) {
      console.error("API call failed:", error);
      throw error;
    }
  }
);
export const createMemberBenefitForCust = createAsyncThunk(
  "customersData/createMemberBenefitForCust",
  async (payload) => {
    try {
      const response = await allAPI.customers.createMemberBenefitForCust(payload);
      if (response.status === 201) {
        return response.data;
      } else {
        throw new Error(`Unexpected status code: ${response.status}`);
      }
    } catch (error) {
      console.error("API call failed:", error);
      throw error;
    }
  }
);
export const updateMemberBenefitForCust = createAsyncThunk(
  "customersData/updateMemberBenefitForCust",
  async (payload) => {
    try {
      const response = await allAPI.customers.updateMemberBenefitForCust(payload);
      if (response.status === 201) {
        return response.data;
      } else {
        throw new Error(`Unexpected status code: ${response.status}`);
      }
    } catch (error) {
      console.error("API call failed:", error);
      throw error;
    }
  }
);
export const deleteMemberBenefitForCust = createAsyncThunk(
  "customersData/deleteMemberBenefitForCust",
  async (payload) => {
    try {
      const response = await allAPI.customers.deleteMemberBenefitForCust(payload);
      if (response.status === 201) {
        return response.data;
      } else {
        throw new Error(`Unexpected status code: ${response.status}`);
      }
    } catch (error) {
      console.error("API call failed:", error);
      throw error;
    }
  }
);

const customerSlice = createSlice({
  name: "customersData",
  initialState,
  reducers: {
    setCustomer: (state, action) => {
      console.log(action, "assign state");
      state.customerDetail = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllCustomers.pending, (state) => {
        console.log("pending");
      })
      .addCase(getAllCustomers.fulfilled, (state, action) => {
        console.log(action.payload, "response");
        state.customers = action.payload;
      })
      .addCase(getAllCustomers.rejected, (state, action) => {
        state.customers = [];
        console.log("rejected", action.error.message);
      })

      .addCase(getAllBulkUploadUsers.pending, (state) => {
        console.log("pending bulkUploadUsers");
      })
      .addCase(getAllBulkUploadUsers.fulfilled, (state, action) => {
        console.log(action.payload, "response bulkUploadUsers");
        state.bulkUploadUsers = action.payload;
      })
      .addCase(getAllBulkUploadUsers.rejected, (state, action) => {
        state.bulkUploadUsers = [];
        console.log("rejected bulkUploadUsers", action.error.message);
      })

      .addCase(getMemberBenefitForCust.pending, (state) => {
        console.log("pending");
      })
      .addCase(getMemberBenefitForCust.fulfilled, (state, action) => {
        state.customersMBData = action.payload;
      })
      .addCase(getMemberBenefitForCust.rejected, (state, action) => {
        state.customersMBData = [];
        console.log("rejected", action.error.message);
      });
  },
});

export const { setCustomer } = customerSlice.actions;

export default customerSlice.reducer;
